<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on" class="d-flex align-start">
        <template v-if="code != null">
          <span
            :class="[
              'px-2',
              'py-1',
              'font-weight-bold',
              textColor,
              'text--darken-2',
              'd-flex',
              'align-center',
            ]"
            :style="{
              backgroundColor: backgroundColor,
              borderRadius: '8px',
              maxWidth: '220px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }"
          >
            <v-icon
              left
              size="18"
              style="font-weight: bold"
              :class="['mr-1', textColor, 'text--darken-2']"
              >{{ icon }}</v-icon
            >
            <span class="text-truncate" style="flex: 1">
              {{ date }}
            </span>
          </span>
        </template>

        <template v-else>
          <span class="d-flex align-center justify-start">
            <span class="text-truncate" style="flex: 1">
              {{ date }}
            </span>
          </span>
        </template>
      </span>
    </template>
    <span>
      <b v-if="code != null">{{ tooltipMessage }}</b>

      <template v-else>
        <small>{{ date }}</small>
      </template>
    </span>
  </v-tooltip>
</template>

<script>
import { getMigrationValidationCode } from "@/helpers/variables/migrations";

export default {
  name: "Period",

  props: {
    date: { type: String, required: true },
    code: { type: String, default: null },
  },

  computed: {
    config() {
      return getMigrationValidationCode(this.$i18n)[this.code] || {};
    },
    tooltipMessage() {
      return typeof this.config.tooltipMessage === "function"
        ? this.config.tooltipMessage(this.dynamicLabel)
        : this.config.tooltipMessage;
    },
    icon() {
      return this.config.icon;
    },
    textColor() {
      return this.config.textColor;
    },
    backgroundColor() {
      return this.config.backgroundColor;
    },
  },
};
</script>
